class CustomQuiz extends HTMLElement {
  constructor() {
    super();

    console.log(
      "%cCUSTOM QUIZ FOR SHOPIFY STORES BY kevinschade.com",
      "font-size: 18px; font-weight: 600; color: #fff;background: #F11D64; padding: 10px 20px; border-radius: 5px; width: 100%"
    );

    this.id = this.dataset.quizId;
    this.graphqlId = this.dataset.graphqlId;
    this.handle = this.dataset.quizHandle;
    this.type = this.dataset.quizType;
    this.myshopify = this.dataset.myshopify;
    this.startQuestionHandle = this.dataset.startQuestionHandle;
    this.resultPageUrl = this.dataset.resultPageUrl;

    this.openQuizButtons = document.querySelectorAll(
      `.open-quiz-button[data-quiz-handle='${this.handle}']`
    );
    this.closeButton = this.querySelector("[data-close]");

    this.setupOpenClose();

    this.questionCards = this.querySelectorAll(".quiz-question-card");

    this.progressBars = this.querySelectorAll(
      ".quiz-overlay-head-progress, .quiz-overlay-progress-desktop"
    );
    this.progressBarStepLabels = this.querySelectorAll(
      ".quiz-overlay-head-progress-step span"
    );

    this.submitButton = this.querySelector(".quiz-submit-button");
    this.loadingOverlay = this.querySelector("custom-quiz-loading-overlay");
    this.emailOverlay = this.querySelector("custom-quiz-email-overlay");

    this.submitUrl = "https://quiz.kevinschade.com/v2/submit";

    window.addEventListener("hashchange", () => {
      this.toggleOnHash();
    });

    if (
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive"
    ) {
      this.selectStartQuestion();
    }

    window.addEventListener("DOMContentLoaded", () => {
      this.toggleOnHash();

      // Open by default
      this.selectStartQuestion();
    });
  }

  toggleOnHash() {
    if (window.location.hash.startsWith("#quiz")) {
      const quizHandle = window.location.hash.split("=")[1];
      if (quizHandle === this.handle) {
        this.selectStartQuestion();
        this.toggle();
        window.location.hash = "";
      }
    }
  }

  setupOpenClose() {
    this.openQuizButtons.forEach((openButton) => {
      openButton.addEventListener("click", () => {
        this.selectStartQuestion();
        this.toggle();
      });
    });

    this.closeButton?.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    const currentState = this.dataset.open === "true";
    this.setAttribute("data-open", !currentState);
  }

  updateProgressBar() {
    let progressPercentage =
      (this.questionStackPointer + 1) / this.questionCards.length;
    progressPercentage = progressPercentage * 100 - 5;

    progressPercentage = progressPercentage > 90 ? 90 : progressPercentage;

    if (this.questionStackPointer == this.questionCards.length) {
      this.progressBarStepLabels.forEach((stepLabel) => {
        stepLabel.textContent = "DATEN SPEICHERN";
      });

      this.progressBars.forEach((progressBar) => {
        progressBar.setAttribute("style", `--progress-percentage: 100%`);
      });

      return;
    }

    this.progressBars.forEach((progressBar) => {
      progressBar.setAttribute(
        "style",
        `--progress-percentage: ${progressPercentage}%`
      );
    });

    console.log(this.getCurrentActiveQuestion())
    const progressLabel = this.getCurrentActiveQuestion()?.dataset.progressLabel;

    this.progressBarStepLabels.forEach((stepLabel, index) => {
      stepLabel.textContent = `${this.questionStackPointer + 1} von ${
        this.questionCards.length
      }: ${ progressLabel || "" }`;
    });
  }

  selectStartQuestion() {
    this.questionStack = [];
    this.questionStackPointer = 0;

    this.questionCards.forEach((card) => {
      card.resetSelection();
    });

    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);

    const newActive = Array.from(this.questionCards).find(
      (card) => card.dataset.quizQuestionHandle === this.startQuestionHandle
    );
    newActive.setAttribute("data-active", "transition");
    setTimeout(() => {
      newActive.setAttribute("data-active", true);
    }, 50);

    this.questionStack.push({
      questionHandle: this.startQuestionHandle,
      answers: null,
    });

    this.updateProgressBar();
    this.progressBars.forEach((progressBar) => {
      progressBar.setAttribute("data-show", true);
    });
    if (this.emailOverlay && this.emailOverlay.dataset.state !== "initial") {
      this.emailOverlay.close();
    }
  }

  next() {
    const currentActiveQuestion = this.getCurrentActiveQuestion();
    const currentSelection = currentActiveQuestion.getCurrentSelection();

    const answers = [];

    // Creating an array of all answer data for the current question and adding it to the stack

    for (var selection of currentSelection) {
      const selectionMapping = JSON.parse(selection.dataset.mapping);
      answers.push(selectionMapping);
    }

    const currentActive = this.questionStack[this.questionStackPointer];
    currentActive.answers = answers;

    this.questionStackPointer = this.questionStackPointer + 1;

    // Going through all answers and adding next questions to the stack, reverse order

    for (var i = currentSelection.length - 1; i >= 0; i--) {
      var selection = currentSelection[i];
      const nextQuestionHandle = selection.dataset.nextQuestionHandle;
      const containsNextQuestion = this.questionStack.some(
        (question) => question.questionHandle === nextQuestionHandle
      );
      if (!containsNextQuestion) {
        this.questionStack.splice(this.questionStackPointer, 0, {
          questionHandle: nextQuestionHandle,
          answers: null,
        });
      }
    }

    // Submitting on end of quiz

    const nextQuestionHandle =
      this.questionStack[this.questionStackPointer].questionHandle;

    // Updating progress bar and hiding active question

    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);
    this.updateProgressBar();

    // Submitting if it's the last question
    if (
      nextQuestionHandle == null ||
      nextQuestionHandle == undefined ||
      nextQuestionHandle == ""
    ) {
      this.submit();
      return;
    }

    // Enabling next question card
    const newActive = Array.from(this.questionCards).find(
      (card) => card.dataset.quizQuestionHandle === nextQuestionHandle
    );
    newActive.setAttribute("data-active", "transition");
    window.scrollTo(0, 0);
    setTimeout(() => {
      newActive.setAttribute("data-active", true);
      this.updateProgressBar();
    }, 50);
  }

  previous() {
    if (this.questionStackPointer === 0) {
      this.toggle();
      return;
    }
    this.selectStartQuestion();
  }

  async submit() {
    this.submitButton.setAttribute("disabled", true);
    this.submitButton.setAttribute("data-loading", true);
    window.scrollTo(0, 0);

    const submitUrl = new URL(this.submitUrl);
    submitUrl.searchParams.set("shop", this.myshopify);
    submitUrl.searchParams.set("quizId", this.graphqlId);

    const postBody = [];

    for (var question of this.questionStack) {
      if (question.answers == null) {
        continue;
      }
      const answers = question.answers.filter(
        (answer) => answer.mappings.length != 0
      );

      postBody.push({
        questionHandle: question.questionHandle,
        answers,
      });
    }

    const submitResult = fetch(submitUrl, {
      method: "POST",
      body: JSON.stringify(postBody),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    this.loadingOverlay.toggle();

    const minimumWait = new Promise((resolve, reject) => {
      setTimeout(resolve, 3000);
    });

    const [submitResultData] = await Promise.all([submitResult, minimumWait]);

    if (!submitResultData.ok) {
      alert(
        "Es ist ein Fehler aufgetreten. Bitte probiere es in ein paar Minuten erneut."
      );
      this.submitButton.removeAttribute("disabled");
      this.submitButton.setAttribute("data-loading", false);
      return;
    }

    const submitResultJson = await submitResultData.json();

    const searchParams = new URLSearchParams();
    searchParams.set("uuid", submitResultJson.uuid);
    const resultPageUrl = this.resultPageUrl + "?" + searchParams.toString();

    this.loadingOverlay.toggle();

    setTimeout(() => {
      this.emailOverlay.open(resultPageUrl);
    }, 501);
  }

  getCurrentActiveQuestion() {
    const currentActive = Array.from(this.questionCards).find(
      (card) => card.dataset.active === "true"
    );
    return currentActive;
  }
}

class CustomQuizQuestionCard extends HTMLElement {
  constructor() {
    super();

    this.multichoice = this.dataset.multichoice === "true";
    this.nextButton = this.querySelector("button.full");
    this.previousButton = this.querySelector(".quiz-question-head-back");
    this.options = this.querySelectorAll(".quiz-question-option");
    this.quiz = this.closest("custom-quiz");
    this.contentButton = this.querySelector(".quiz-question-content");
    this.quizContent = document.querySelector("custom-quiz-content");

    this.registerListeners();
  }

  registerListeners() {
    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        if(!this.multichoice) {
          this.resetSelection();
        }

        // If already two options selected and user wants to select a third option, show warning
        if(this.multichoice && option.dataset.select === "false") {
          const currentSelectedOptionsLength = Array.from(this.options).filter(option => option.dataset.select === "true").length;
          if(currentSelectedOptionsLength >= 2) {
            alert("Du kannst nur maximal zwei Optionen auswählen.")
            return;
          }
        }
        this.selectOption(option);
        this.validateForm();
        if (!this.multichoice) {
          this.quiz.next();
        }
      });
    });

    this.nextButton?.addEventListener("click", () => {
      this.quiz.next();
    });

    this.previousButton?.addEventListener("click", () => {
      this.quiz.previous();
    });

    this.contentButton?.addEventListener("click", () => {
      this.quizContent.toggle(this.dataset.quizQuestionIndex);
    });
  }

  validateForm() {
    let isValid = this.getCurrentSelection().length > 0;

    if (isValid) {
      this.nextButton?.removeAttribute("disabled");
    } else {
      this.nextButton?.setAttribute("disabled", true);
    }

    return isValid;
  }

  getCurrentSelection() {
    return Array.from(this.options).filter(
      (option) => option.dataset.select === "true"
    );
  }

  getCurrentTags() {
    return this.getCurrentSelection().map((option) => option.dataset.tag);
  }

  selectOption(optionEl) {
    const currentOptionState = optionEl.dataset.select === "true";
    optionEl.setAttribute("data-select", !currentOptionState);
  }

  resetSelection() {
    this.getCurrentSelection().forEach((option) => {
      option.setAttribute("data-select", false);
    });
  }
}

class CustomQuizContent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("quiz-question-content-popup") ||
        e.target.tagName === "path" ||
        e.target.tagName === "svg" ||
        e.target.hasAttribute("data-close")
      ) {
        this.closeAll();
      }
    });
  }

  closeAll() {
    this.querySelectorAll(
      ".quiz-question-content-popup-item[data-show='true']"
    ).forEach((item) => {
      this.toggle(item.dataset.quizQuestionIndex);
    });
  }

  toggle(questionIndex) {
    const item = this.querySelector(
      `.quiz-question-content-popup-item[data-quiz-question-index='${questionIndex}']`
    );
    const currentState = item.dataset.show === "true";

    item.setAttribute("data-show", "transition");
    const delay = currentState ? 300 : 50;
    setTimeout(() => {
      item.setAttribute("data-show", !currentState);
    }, delay);
  }
}

class CustomQuizLoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  toggle() {
    const newState = this.dataset.active !== "true";

    if (newState) {
      this.setAttribute("data-active", "transition");
      this.progressPercentage = 0;

      setTimeout(() => {
        this.setAttribute("data-active", true);

        this.interval = setInterval(() => {
          this.progressPercentage = this.progressPercentage + 1;
          this.querySelector(
            ".quiz-loading-overlay-circle-wrapper"
          ).setAttribute(
            "style",
            `--progress-percentage: ${this.progressPercentage}%`
          );
          this.querySelector(
            ".quiz-loading-overlay-circle-progress"
          ).textContent =
            (this.progressPercentage > 100 ? 100 : this.progressPercentage) +
            "%";

          if (this.progressPercentage >= 100) {
            clearInterval(this.interval);
            console.log("CLearing");
          }
        }, 35);
      }, 50);
    } else {
      this.setAttribute("data-active", "animate-reverse");

      setTimeout(() => {
        this.setAttribute("data-active", false);
      }, 500);
    }
  }
}

class CustomQuizEmailOverlay extends HTMLElement {
  constructor() {
    super();

    this.emailInput = this.querySelector("#quiz-email-overlay__email");
    this.firstNameInput = this.querySelector("#quiz-email-overlay__first-name");
    this.submitButton = this.querySelector(".quiz-email-overlay__form-submit");
    this.continueButtons = this.querySelectorAll(
      ".quiz-email-overlay__form-skip"
    );

    this.submitButton.addEventListener("click", async () => {
      const email = this.emailInput.value;
      const firstName = this.firstNameInput.value;
      if (email === "" || firstName === "") {
        alert("Bitte gib eine gültige E-Mail-Adresse und einen Vornamen ein.");
        return;
      }
      await this.submitToKlaviyo(email, firstName);
      this.redirectWhenResultPageIsReady();
    });

    this.continueButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.redirectWhenResultPageIsReady();
      });
    });
  }


  // Sometimes the result page throws a 404, so we need to check if it is ready
  async redirectWhenResultPageIsReady() {
    let resultPageUrl = this.dataset.resultPageUrl;
    const searchParams = new URLSearchParams();
    searchParams.set("rid", Date.now().toString());

    if(!resultPageUrl.includes("?")) {  
      resultPageUrl = resultPageUrl + "?" + searchParams.toString();
    }

    window.location.href = resultPageUrl;

    /*
    const intervalId = setInterval(async () => {
      let resultPageUrl = this.dataset.resultPageUrl;
      const searchParams = new URLSearchParams();
      searchParams.set("rid", Date.now().toString());

      if(!resultPageUrl.includes("?")) {  
        resultPageUrl = resultPageUrl + "?" + searchParams.toString();
      }

      const fetchResultPage = await fetch(resultPageUrl);
      if (fetchResultPage.ok) {
        clearInterval(intervalId);
        window.location.href = url.toString();
      } else {
        console.log("[QUIZ] Result page is not ready yet, waiting...");
      }
    }, 250);*/
  }

  async submitToKlaviyo(email, firstName) {
    const klaviyoListId = "YrGFQw";
    const klaviyoPublicAPIKey = "V9nkLM";

    const klaviyoBody = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Quiz E-Mail Input",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                first_name: firstName,
                properties: { quizResultPage: this.dataset.resultPageUrl },
                location: {
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
              },
              meta: {
                patch_properties: {
                  append: { quizResultPage: this.dataset.resultPageUrl },
                },
              },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: klaviyoListId } } },
      },
    };

    const fetchRes = await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" +
        klaviyoPublicAPIKey,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-07-15",
        },
        body: JSON.stringify(klaviyoBody),
      }
    );

    if (!fetchRes.ok) {
      console.error("Failed to submit email to Klaviyo");
    }
  }

  open(resultPageUrl) {
    const currentDomain = window.location.origin;
    if (resultPageUrl.startsWith("/")) {
      resultPageUrl = currentDomain + resultPageUrl;
    }
    this.setAttribute("data-active", "transition");
    this.dataset.resultPageUrl = resultPageUrl;
    setTimeout(() => {
      this.setAttribute("data-active", true);
    }, 50);
  }

  close() {
    this.setAttribute("data-active", false);
  }
}

customElements.define("custom-quiz-question-card", CustomQuizQuestionCard);
customElements.define("custom-quiz", CustomQuiz);
customElements.define("custom-quiz-content", CustomQuizContent);
customElements.define("custom-quiz-loading-overlay", CustomQuizLoadingOverlay);
customElements.define("custom-quiz-email-overlay", CustomQuizEmailOverlay);
